import { jsx as _jsx } from "react/jsx-runtime";

function SvgArrowDown() {
  return _jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: _jsx("path", {
      d: "M8.067 9h7.865a.5.5 0 01.384.82l-3.932 4.719a.5.5 0 01-.768 0l-3.933-4.72A.5.5 0 018.067 9z"
    }, void 0)
  }), void 0);
}

export default SvgArrowDown;